import {useEffect} from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useNavigate, useParams} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useGetQuery, useUpdateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import * as changeRequestApi from "../../api/workOrderApi/changeRequestApi";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {
  EQChangeRequest,
  initializeChangeRequest,
} from "../../models/serverModels/workOrder/EQChangeRequest";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import ChangeRequestForm from "./ChangeRequestForm";
import {yupResolver} from "@hookform/resolvers/yup";
import {changeRequestSchema} from "../../validation/changeRequestSchema";

const UpdateChangeRequest = () => {
  const {id} = useParams();

  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {data: changeRequest, isLoading: isGetLoading} = useGetQuery<ResponseItem<EQChangeRequest>>(
    {
      key: ["ChangeRequest", {token: tokenState, id: parseInt(id!)}],
      api: () => changeRequestApi.getItem({token: tokenState, id: parseInt(id!)}),
    }
  );

  const {mutate: updateMutate, isLoading: isUpdateLoading} = useUpdateMutation<
    ResponseItem<EQChangeRequest>,
    Params.Update<EQChangeRequest>
  >({
    api: changeRequestApi.update,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("update");
        navigate("/WorkOrder/ChangeRequestList");
        queryClient.invalidateQueries("ChangeRequestList");
      },
    },
  });

  const methods = useForm<EQChangeRequest>({
    defaultValues: changeRequest?.item || initializeChangeRequest(),
    resolver: yupResolver(changeRequestSchema),
  });

  const {reset} = methods;

  useEffect(() => {
    reset(changeRequest?.item);
  }, [changeRequest?.item, reset]);

  const onSubmit: SubmitHandler<EQChangeRequest> = (data) => {
    updateMutate({
      id: parseInt(id!),
      token: tokenState,
      item: {...initializeChangeRequest(), ...data},
    });
  };
  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="변경요청서 수정" />
      {isUpdateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <ChangeRequestForm captionColor="#546E7A" />
            <ConfirmButtonGroup
              link={`/WorkOrder/ChangeRequestList`}
              cancelText="취소"
              confirmText="수정"
            />
          </form>
        </FormSection>
      )}
    </FormProvider>
  );
};

export default UpdateChangeRequest;
